/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_SubtitleInputs */

const en_landing_faq_subtitle = /** @type {(inputs: Landing_Faq_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What research, distribution, and technology teams ask us first.`)
};

/**
* | output |
* | --- |
* | "What research, distribution, and technology teams ask us first." |
*
* @param {Landing_Faq_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_subtitle = /** @type {((inputs?: Landing_Faq_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_subtitle(inputs)
});